import React from 'react'
import CIcon from '@coreui/icons-react'

const _nav = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Dashboard',
    to: '/',
    icon: 'cil-speedometer',
  }, {
    _tag: 'CSidebarNavItem',
    name: 'Books',
    to: '/books',
    icon: 'cil-book',
  }, {
    _tag: 'CSidebarNavItem',
    name: 'Bookmarks',
    to: '/bookmarks',
    icon: 'cil-bookmark',
  }, {
    _tag: 'CSidebarNavItem',
    name: 'Pages',
    to: '/pages',
    icon: 'cil-file',
  },
]

export default _nav
